import React from 'react';
export default function AppCard({ icon: Icon, iconColor, title, description, href }) {
  const colorClasses = {
    red: 'bg-card-red',
    blue: 'bg-card-blue',
    orange: 'bg-card-orange',
    teal: 'bg-card-teal',
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="card-link md:h-64 rounded-xl bg-white p-6"
    >
        <div className="w-[80%] h-full">
            <div className={`w-14 h-14 ${colorClasses[iconColor] || 'bg-slate-500'} rounded-lg flex items-center mb-6 justify-center`}>
                {Icon && <Icon className="w-6 h-6 text-white" />}
            </div>
            <h3 className="text-2xl font-extrabold mb-6 tracking-[0.31px]  text-[#034D82] ">{title}</h3>
            <p className="text-base text-[#717182] font-medium font-segoe tracking-[0%] line-clamp-2 overflow-hidden">{description}</p>
        </div>
    </a>
  );
}
